export default __webpack_public_path__ + "static/media/imgs6.5abe1a79.png";